<template>
  <div class="grow">
    <template v-if="booking?.currentBalance">
      <HandoverPaymentForm v-if="$can('charge', subject('Booking', booking))" :booking="booking" />
      <!-- Without charge permission the customer can only pay by payment link (ADR 0021). -->
      <ExternalHandoverPayment v-else :booking="booking" @refresh="refetchBooking" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { watch } from 'vue';
import { useBooking } from '@/queries/use-bookings';
import { useRoute } from 'vue-router';
import HandoverPaymentForm from './HandoverPaymentForm.vue';
import ExternalHandoverPayment from './ExternalHandoverPayment.vue';
import { subject } from '@casl/ability';

const route = useRoute();

const { data: booking, refetch: refetchBooking } = useBooking(route.params.id as string);

// The amounts to charge depend on the balance, so never render the form from a cached booking
// without it (seen in production as ROS-FRONTEND-ZN)
watch(
  () => !!booking.value && !booking.value.currentBalance,
  (isMissingBalance) => {
    if (isMissingBalance) void refetchBooking();
  },
  { immediate: true },
);
</script>
